<div
  class="rise-playlist-container attribute-editor-component tw-mt-[12px] tw-px-[20px]"
  rvSpinner="rise-playlist-loader"
  [rvShowSpinner]="playlistComponentService.loading"
>
  <!-- default view -->
  @if (!showComponentsDropdown()) {
    <button
      id="te-playlist-select-templates"
      type="button"
      matButton="outlined"
      class="add-component-button"
      aria-label="Select presentations"
      (click)="playlistService.showAddTemplates()"
    >
      <mat-icon svgIcon="add" aria-hidden="true" />
      Select Presentations
    </button>
  } @else {
    <button
      id="addPlaylistItemButton"
      type="button"
      matButton="outlined"
      class="add-component-button"
      aria-label="Add playlist item"
      (click)="showAddPlaylistItem()"
    >
      <mat-icon svgIcon="add" aria-hidden="true" />
      Add Playlist Item
    </button>
  }
  <div
    class="templates-selector te-scrollable-container"
    [shown]="playlistService.playlistItems?.length"
  >
    <rv-sortable [sortableService]="sortableService">
      <div id="sortable-instructions" class="sr-only">
        Use Space to select an item, then use Up and Down arrow keys to move it.
        Press Space again to drop the item in its new position, or press Escape
        to cancel.
      </div>
      @for (
        item of playlistService.playlistItems;
        track item;
        let key = $index
      ) {
        @let itemRequiresUpgrade = requiresUpgrade(item);
        @let itemIcon = getPlaylistItemIcon(item);

        <div
          rvSortableItem
          class="component-item"
          tabindex="0"
          [class.component-item-disabled]="itemRequiresUpgrade"
          [class.component-item-editing-label]="item.editing"
          (keyup.enter)="onPlaylistItemEnterKeyup(item, key, $event)"
        >
          <rv-sortable-handle></rv-sortable-handle>
          <div class="component-item-label">
            <div
              class="component-item-label-main"
              (click)="
                !itemRequiresUpgrade &&
                  !isEmbeddedTemplate(item) &&
                  !item.editing &&
                  editPlaylistItem(key)
              "
            >
              @if (isEmbeddedTemplate(item)) {
                <mat-icon
                  aria-hidden="true"
                  svgIcon="presentation"
                  class="streamline-component-icon u_align-middle tw-top-0 tw-ml-[8px]"
                ></mat-icon>
              } @else if (playlistService.isMatIcon(item)) {
                <mat-icon
                  aria-hidden="true"
                  [svgIcon]="itemIcon"
                  class="streamline-component-icon mr-0 u_align-middle tw-top-0 tw-ml-[8px]"
                ></mat-icon>
              } @else {
                <streamline-icon
                  aria-hidden="true"
                  class="streamline-component-icon mr-0 tw-top-0 tw-ml-[8px]"
                  name="{{ itemIcon }}"
                  width="18"
                  height="18"
                ></streamline-icon>
              }
              @if (!isEmbeddedTemplate(item)) {
                <span
                  id="playlist-item-edit-{{ key }}"
                  class="component-item-label-text"
                  [focus-outline]="-2"
                  [hidden]="item.editing"
                  [class.danger]="item.fileMissing"
                  title="{{ getDisplayName(item) }}"
                >
                  {{ getDisplayName(item) }}
                </span>
                <div [shown]="item.editing" class="mr-2 flex-grow">
                  <input
                    #ItemName
                    id="input-item-name-{{ key }}"
                    aria-label="Edit playlist item label"
                    attr.aria-describedby="playlist-item-edit-{{ key }}"
                    class="w-100 form-control p-2 h-auto"
                    type="text"
                    [ngModel]="getDisplayName(item)"
                    (blur)="saveItemName(key, $event)"
                    (keyup)="itemNameKeyup(key, $event)"
                  />
                </div>
              } @else {
                <div
                  [shown]="!item.editing"
                  class="component-item-label-embedded"
                >
                  <span
                    class="component-item-label-text"
                    title="{{ item.label || item.name }}"
                    >{{ item.label || item.name }}</span
                  >
                  <div
                    class="templates-status templates-status-inline"
                    [ngClass]="{
                      'templates-status-revised':
                        item.revisionStatusName === 'Revised' || item.removed,
                    }"
                  >
                    {{ item.revisionStatusName }}
                  </div>
                </div>
              }
            </div>
            @if (itemRequiresUpgrade) {
              @if (item.tagName === 'rise-powerbi') {
                <upgrade-notice
                  #UpgradeNotice
                  feature="power_bi"
                ></upgrade-notice>
              } @else if (item.tagName === 'rise-domo') {
                <upgrade-notice #UpgradeNotice feature="domo"></upgrade-notice>
              }
            }
          </div>
          @if (!itemRequiresUpgrade) {
            <div class="component-item-actions">
              <template-attribute-components-menu-inline
                class="component-item-menu-inline"
                [key]="key"
                [isUserComponents]="true"
                [componentVisibility]="true"
                [componentRequiresUpgrade]="itemRequiresUpgrade"
                [isDataComponent]="false"
                [showVisibilityToggle]="false"
                [showDuplicateAction]="true"
                [displayName]="getDisplayName(item)"
                (rename)="renameItem($event)"
                (duplicate)="onDuplicateClick($event)"
                (remove)="onDeleteClick($event)"
              ></template-attribute-components-menu-inline>

              @if (item.fileMissing) {
                <mat-icon
                  aria-label="Missing file"
                  svgIcon="warning-filled"
                  color="warn"
                  class="file-missing-icon"
                  matTooltip="Missing file"
                  matTooltipClass="menu-tooltip"
                ></mat-icon>
              }

              <button
                type="button"
                class="component-item-duration"
                [attr.aria-label]="'Edit duration for ' + getDisplayName(item)"
                (click)="editProperties(key)"
                (pointerdown)="onDurationPointerDown($event)"
                matTooltip="Edit Duration"
                matTooltipClass="menu-tooltip"
                matTooltipShowDelay="1000"
              >
                {{ durationToText(item) }}
              </button>

              <template-attribute-components-menu-dropdown
                class="component-item-menu-dropdown"
                [key]="key"
                [isUserComponents]="true"
                [componentVisibility]="true"
                [componentRequiresUpgrade]="itemRequiresUpgrade"
                [isDataComponent]="false"
                [showVisibilityToggle]="false"
                [showDuplicateAction]="true"
                [displayName]="getDisplayName(item)"
                (rename)="renameItem($event)"
                (duplicate)="onDuplicateClick($event)"
                (remove)="onDeleteClick($event)"
              ></template-attribute-components-menu-dropdown>
            </div>
          }
        </div>
      }
    </rv-sortable>
  </div>
</div>
<!-- "edit" view -->
<div
  class="playlist-item-container attribute-editor-component"
  style="display: none"
  rvSpinner="rise-playlist-loader"
  [rvShowSpinner]="playlistComponentService.loading"
>
  <div class="form-group has-feedback">
    <div class="attribute-editor-row">
      <label class="control-label" for="te-playlist-item-duration"
        >Duration:</label
      >
      <div class="flex-row" [shown]="selectedItem['play-until-done-supported']">
        <mat-checkbox
          name="pud"
          id="te-playlist-item-pud-true"
          [ngModel]="selectedItem['play-until-done']"
          (click)="savePlayUntilDone()"
        ></mat-checkbox>
        <span> Play Until Done </span>
      </div>
    </div>
    <div
      class="attribute-editor-row input-group"
      [shown]="!selectedItem['play-until-done']"
    >
      <input
        type="number"
        id="te-playlist-item-duration"
        class="form-control"
        [ngClass]="{
          'duration-input-group': selectedItem['play-until-done-supported'],
        }"
        [(ngModel)]="selectedItem.duration"
        (debounceEvent)="saveProperties()"
        placeholder="Enter duration"
      />
      <span class="input-group-addon">Seconds</span>
    </div>
    <div class="attribute-editor-row mt-4">
      <label class="control-label" for="te-playlist-item-transition"
        >Transition between playlist items:</label
      >
      <select
        id="te-playlist-item-transition"
        [(ngModel)]="selectedItem['transition-type']"
        class="form-control"
        (change)="saveProperties()"
      >
        <option value="normal">No transition</option>
        <option value="fadeIn">Fade in</option>
        <option value="slideFromLeft">Slide from left</option>
        <option value="slideFromRight">Slide from right</option>
        <option value="slideFromTop">Slide from top</option>
        <option value="slideFromBottom">Slide from bottom</option>
        <option value="stripesHorizontal">Stripes horizontal</option>
        <option value="stripesVertical">Stripes vertical</option>
        <option value="zoomIn">Zoom in</option>
      </select>
    </div>
    @if (selectedItem?.timeline) {
      <div class="attribute-editor-row mt-4">
        <label class="control-label">Timeline:</label>
        <timeline-textbox
          [(timelineObject)]="selectedItem.timeline"
          (timelineChange)="saveTimeline()"
          inputId="-playlistItem"
        >
        </timeline-textbox>
      </div>
    }
  </div>
</div>
